/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Template API
 * Something something. <br><br>The spec is available at <a href='/swagger/api.json'>/swagger/api.json</a>.
 * OpenAPI spec version: 0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ApiAppError,
  CreateLocationRequest,
  CreateLocationResponse,
  GetLocationResponse,
  GetLocationsResponse,
  UpdateLocationRequest,
  UpdateLocationResponse
} from './schemas'
import { getApi } from '../client';
import type { ErrorType, BodyType } from '../client';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary Create Location
 */
export const createLocation = (
    createLocationRequest: BodyType<CreateLocationRequest>,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<CreateLocationResponse>(
      {url: `/location`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createLocationRequest, signal
    },
      options);
    }
  


export const getCreateLocationMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{data: BodyType<CreateLocationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{data: BodyType<CreateLocationRequest>}, TContext> => {
    
const mutationKey = ['createLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLocation>>, {data: BodyType<CreateLocationRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createLocation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof createLocation>>>
    export type CreateLocationMutationBody = BodyType<CreateLocationRequest>
    export type CreateLocationMutationError = ErrorType<ApiAppError>

    /**
 * @summary Create Location
 */
export const useCreateLocation = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLocation>>, TError,{data: BodyType<CreateLocationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof createLocation>>,
        TError,
        {data: BodyType<CreateLocationRequest>},
        TContext
      > => {

      const mutationOptions = getCreateLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Delete Location
 */
export const deleteLocation = (
    id: string,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<void>(
      {url: `/location/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteLocationMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLocation>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLocation(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLocationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLocation>>>
    
    export type DeleteLocationMutationError = ErrorType<ApiAppError>

    /**
 * @summary Delete Location
 */
export const useDeleteLocation = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLocation>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteLocation>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Location
 */
export const getLocation = (
    id: string,
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetLocationResponse>(
      {url: `/location/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationQueryKey = (id: string,) => {
    return [`/location/${id}`] as const;
    }

    
export const getGetLocationQueryOptions = <TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ApiAppError>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocation>>> = ({ signal }) => getLocation(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getLocation>>>
export type GetLocationQueryError = ErrorType<ApiAppError>


export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ApiAppError>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocation>>,
          TError,
          Awaited<ReturnType<typeof getLocation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Location
 */

export function useGetLocation<TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ApiAppError>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Location
 */
export const prefetchGetLocation = async <TData = Awaited<ReturnType<typeof getLocation>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocation>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetLocationQueryOptions(id,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


/**
 * @summary Update Location
 */
export const updateLocation = (
    id: string,
    updateLocationRequest: BodyType<UpdateLocationRequest>,
 options?: SecondParameter<typeof getApi>,) => {
      
      
      return getApi<UpdateLocationResponse>(
      {url: `/location/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLocationRequest
    },
      options);
    }
  


export const getUpdateLocationMutationOptions = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{id: string;data: BodyType<UpdateLocationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{id: string;data: BodyType<UpdateLocationRequest>}, TContext> => {
    
const mutationKey = ['updateLocation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, {id: string;data: BodyType<UpdateLocationRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateLocation(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    export type UpdateLocationMutationBody = BodyType<UpdateLocationRequest>
    export type UpdateLocationMutationError = ErrorType<ApiAppError>

    /**
 * @summary Update Location
 */
export const useUpdateLocation = <TError = ErrorType<ApiAppError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,{id: string;data: BodyType<UpdateLocationRequest>}, TContext>, request?: SecondParameter<typeof getApi>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        {id: string;data: BodyType<UpdateLocationRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateLocationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Get Locations
 */
export const getLocations = (
    
 options?: SecondParameter<typeof getApi>,signal?: AbortSignal
) => {
      
      
      return getApi<GetLocationsResponse>(
      {url: `/locations`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLocationsQueryKey = () => {
    return [`/locations`] as const;
    }

    
export const getGetLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<ApiAppError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof getApi>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLocationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLocations>>> = ({ signal }) => getLocations(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getLocations>>>
export type GetLocationsQueryError = ErrorType<ApiAppError>


export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<ApiAppError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocations>>,
          TError,
          Awaited<ReturnType<typeof getLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<ApiAppError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLocations>>,
          TError,
          Awaited<ReturnType<typeof getLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<ApiAppError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Locations
 */

export function useGetLocations<TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<ApiAppError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLocationsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get Locations
 */
export const prefetchGetLocations = async <TData = Awaited<ReturnType<typeof getLocations>>, TError = ErrorType<ApiAppError>>(
 queryClient: QueryClient,  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLocations>>, TError, TData>>, request?: SecondParameter<typeof getApi>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetLocationsQueryOptions(options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


